// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-1lcBR","title":"title-qH39G","text":"text-m4keO","footer":"footer-25v15","button":"button-ZNM5x"};